import { render, staticRenderFns } from "./doctor_main.vue?vue&type=template&id=16674c68&scoped=true&"
import script from "./doctor_main.vue?vue&type=script&lang=js&"
export * from "./doctor_main.vue?vue&type=script&lang=js&"
import style0 from "./doctor_main.vue?vue&type=style&index=0&id=16674c68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16674c68",
  null
  
)

component.options.__file = "doctor_main.vue"
export default component.exports